module.exports = __webpack_public_path__ + "img/2.bde64350.webp";